import { useTranslation } from "react-i18next";
import ConfiguratorLogTab from "@/components/price-generator/ConfiguratorLogTab";
import { PageTitleBar } from "@/components/ui/PageTitleBar";

export default function ConfiguratorLog() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="relative z-20 h-[60px] flex-shrink-0 overflow-hidden border-b bg-background">
        <PageTitleBar
          className="h-full border-0"
          rowClassName="h-full min-h-0 items-center"
          title={t("sidebar.configuratorLog", "Konfigurátor log")}
        />
      </div>
      <div className="min-h-0 flex-1 min-w-0 overflow-hidden">
        <div className="h-full min-h-0 overflow-auto p-3 sm:p-4">
          <ConfiguratorLogTab />
        </div>
      </div>
    </div>
  );
}

